var React = require('react');

function AngleUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.70312 0.453125C8.125 0.03125 8.82812 0.03125 9.25 0.453125L15.625 6.82812C16.0938 7.29688 16.0938 8 15.625 8.42188L14.5938 9.5C14.125 9.92188 13.4219 9.92188 13 9.5L8.45312 4.95312L3.95312 9.5C3.53125 9.92188 2.82812 9.92188 2.35938 9.5L1.32812 8.42188C0.859375 8 0.859375 7.29688 1.32812 6.82812L7.70312 0.453125Z","fill":"#313444"}));
}

AngleUp.defaultProps = {"width":"17","height":"10","viewBox":"0 0 17 10","fill":"none"};

module.exports = AngleUp;

AngleUp.default = AngleUp;
